// createApi
import api from '..'

// paths
import {LECTURE} from '../paths'

// helpers - serializeQueryArgs
import serializeQueryArgs from '../helpers/serializeQueryArgs'
import filterQueryUrlCreater from '../helpers/filterQueryUrlCreater'

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    lectures: builder.query({
      query: (credentials) => ({
        url: filterQueryUrlCreater({baseUrl: LECTURE, endpointData: credentials.endpointData}),
        method: 'GET',
      }),
      serializeQueryArgs,
      providesTags: (response, error, arg) => {
        const result = response?.data?.data

        return result
          ? [...result.map(({id}) => ({type: 'LECTURES', id})), {type: 'LECTURES', id: 'LIST'}]
          : [{type: 'LECTURES', id: 'LIST'}]
      },
    }),
    createLecture: builder.mutation({
      query: (credentials) => ({
        url: LECTURE + 'create-lecture',
        method: 'POST',
        body: credentials.endpointData,
      }),
      serializeQueryArgs,
      invalidatesTags: [{type: 'LECTURES', id: 'LIST'},'CALENDAR'],
    }),
    updateLecture: builder.mutation({
      query: (credentials) => ({
        url: `${LECTURE}${credentials.endpointData.id}/`,
        method: 'PUT',
        body: credentials.endpointData.formData,
      }),
      serializeQueryArgs,
      invalidatesTags: (response, error, arg) => {
        return [{type: 'LECTURES', id: arg.endpointData.id},'CALENDAR']
      },
    }),
    deleteLecture: builder.mutation({
      query: (credentials) => ({
        url: `${LECTURE}${credentials.endpointData.id}/`,
        method: 'DELETE',
      }),
      serializeQueryArgs,
      invalidatesTags: (response, error, arg) => {
        return [{type: 'LECTURES', id: arg.endpointData.id},'CALENDAR']
      },
    }),
  }),
})

export const {
  useLecturesQuery,
  useLazyLecturesQuery,
  useCreateLectureMutation,
  useUpdateLectureMutation,
  useDeleteLectureMutation,
} = extendedApi
